/**
 * @fileoverview POST handler for the "/engagement/prediction_filters_preview/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPredictionFiltersPreviewAppGroupIdType } from "./constants";
import type {
  GetEngagementPredictionFiltersPreviewAppGroupIdProps,
  EngagementPredictionFiltersPreviewAppGroupIdResult,
} from "./types";

export const getEngagementPredictionFiltersPreviewAppGroupId = reactQueryFetcherAdapter(
  engagementPredictionFiltersPreviewAppGroupIdType,
  (
    signal: AbortSignal,
    {
      appGroupId,
      condition,
      modelType,
      conditionFilters,
      universeFilters,
      timeWindow,
      slowTraining,
      useSnowflake,
      totalSegmentUsersOnly,
    }: GetEngagementPredictionFiltersPreviewAppGroupIdProps
  ): Promise<EngagementPredictionFiltersPreviewAppGroupIdResult> => {
    return fetch(
      `/engagement/prediction_filters_preview/${appGroupId}`,
      "POST",
      {
        condition,
        model_type: modelType,
        condition_filters: conditionFilters,
        universe_filters: universeFilters,
        time_window: timeWindow,
        slow_training: slowTraining,
        use_snowflake: useSnowflake,
        total_segment_users_only: totalSegmentUsersOnly,
      },
      { signal }
    );
  }
);
